import gsap from 'gsap/dist/gsap';
import vars from '../helpers';

function parallaxIt($link, e, target, movement) {
	const $this = $link;
	const relX = e.pageX - $this.offset().left;
	const relY = e.pageY - $this.offset().top;

	gsap.to(target, {
		duration: 1,
		x: (relX - $this.width() / 2) / $this.width() * movement,
		y: (relY - $this.height() / 2) / $this.height() * movement,
	});
}

function callParallax($link, e) {
	parallaxIt($link, e, '.index__people-img--1', 4);
	parallaxIt($link, e, '.index__people-img--2', -4);
}

export function indexAnimation() {
	const $index = $('.index');
	const $indexContainer = $index.find('.index__container');
	const $titleOne = $index.find('.index__title-in');
	const $titleTwo = $index.find('.index__title-inner');
	const $description = $index.find('.index__description');
	const $indexLink1 = $index.find('.index__link--1');
	const $indexLink2 = $index.find('.index__link--2');
	const $indexLink3 = $index.find('.index__link--3');
	const $indexLink4 = $index.find('.index__link--4');
	const $indexLink5 = $index.find('.index__link--5');
	const $indexLink6 = $index.find('.index__link--6');
	const $indexElement = $index.find('.index__element');
	const $indexContent = $index.find('.index__content');
	const $indexLinks = $index.find('.index__links');

	if (!vars.isMobile()) {
		gsap.timeline({
			onStart() {
				$indexContainer.removeClass('is-hidden');
			},
			onComplete() {
				$indexContent.addClass('is-active');
			},
		})
			.from($titleOne, {
				x: 100,
				autoAlpha: 0,
			})
			.from($titleTwo, {
				duration: 0.8,
				x: -70,
				autoAlpha: 0,
				onStart() {
					$indexElement.addClass('is-active');
				},
			}, '-=0.4')
			.from($description, {
				delay: 2.1,
				autoAlpha: 0,
			})
			.from($indexLink1, {
				y: 50,
				autoAlpha: 0,
			})
			.from($indexLink4, {
				y: 50,
				autoAlpha: 0,
			})
			.from($indexLink6, {
				y: 50,
				autoAlpha: 0,
			})
			.from($indexLink2, {
				y: 50,
				autoAlpha: 0,
			})
			.from($indexLink5, {
				y: 50,
				autoAlpha: 0,
			})
			.from($indexLink3, {
				y: 50,
				autoAlpha: 0,
			})
			.from($indexContent, {
				y: 20,
				autoAlpha: 0,
			});

		const $indexLink = $index.find('.index__link');
		const timeout = null;

		$indexLink.on('mousemove', (e) => {
			if (timeout) {
				clearTimeout(timeout);
			}

			setTimeout(callParallax($indexLink, e), 400);
		});
	} else {
		gsap.timeline({
			onStart() {
				$indexContainer.removeClass('is-hidden');
			},
			onComplete() {
				$indexContent.addClass('is-active');
			},
		})
			.from($titleOne, {
				x: -70,
				autoAlpha: 0,
				onComplete() {
					$indexElement.addClass('is-active');
				},
			})
			.from($titleTwo, {
				duration: 0.8,
				x: 100,
				autoAlpha: 0,
			})
			.from($description, {
				autoAlpha: 0,
			})
			.from($indexLinks, {
				delay: 2.1,
				y: 50,
				autoAlpha: 0,
			});
	}
}
